import en from 'vuetify/src/locale/en.ts'

export default {
}
